import React, { FC, ReactNode, useState } from 'react';

import style from './AdvancedDropdownListItem.style.module.scss';
import Icon from '@/src/v2/components/Icon';
import Link from 'next/link';

type Props = {
  icon?: ReactNode;
  label: string;
  onClick?: () => void;
  className?: string;
  customRender?: (item: {
    icon?: ReactNode;
    label: string;
    onClick?: () => void;
  }) => ReactNode;
  isSelected?: boolean;
  isAvailable?: boolean;
  disable?: boolean;
};

const DropdownListItem: FC<Props> = ({
  icon = null,
  label,
  onClick,
  customRender,
  className = '',
  isSelected = false,
  isAvailable = true,
  disable = false,
}) => {
  const [openPlanList, setOpenPlanList] = useState(false);
  const MENU_PRICING = process.env.NEXT_PUBLIC_PRICING || 'false';
  return (
    <>
      <div
        onClick={
          disable === false
            ? onClick
            : () => {
                setOpenPlanList(true);
              }
        }
        className={`${style['dropdown-list-item']} ${
          icon ? style['dropdown-list-item--with-icon'] : ''
        } ${className} ${
          !isAvailable || disable
            ? style['dropdown-list-item--unavailable']
            : ''
        }`}
      >
        {customRender ? (
          <>{customRender({ label, icon, onClick })}</>
        ) : (
          <>
            {icon && (
              <div className={style['icon']}>
                {typeof icon === 'string' ? <Icon icon={icon} /> : icon}
              </div>
            )}

            <span>{label}</span>
            {isSelected && (
              <div
                style={{ width: '14px', height: '14px', marginLeft: 'auto' }}
              >
                <Icon icon={'checkPrimary'} />
              </div>
            )}
            {disable === true && (
              <>
                <Link
                  href={'/contact-us'}
                  className={style['dropdown-list-item--upgrade']}
                >
                  Contact Us
                </Link>
              </>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default DropdownListItem;
